import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { buildWebPage } from "../components/schema";
import { PageHeader } from "../components/PageHeader";
import { About } from "../components/About";

export default function AziendaPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="azienda-page">
      <Seo
        title="VETRO DESIGN ITALIA | Esperti in vetrate panoramiche VEPA"
        description="VETRO DESIGN ITALIA, esperti in vetrate panoramiche VEPA ad Osimo (Ancona). Esperienza, progettazione e installazione di soluzioni in vetro indoor & outdoor in tutte le Marche."
        path="/azienda-vetrate-panoramiche-vepa"
        jsonLd={buildWebPage("Chi siamo · VETRO DESIGN ITALIA", "/azienda-vetrate-panoramiche-vepa", "VETRO DESIGN ITALIA, esperti in vetrate panoramiche VEPA ad Osimo (Ancona) e in tutte le Marche.", "Chi Siamo")}
      />
      <Navbar />
      <PageHeader
        eyebrow="Azienda"
        h1="Esperienza, progettazione e installazione di soluzioni in vetro"
        intro="Operiamo ad Osimo (Ancona) e in tutte le Marche con un team specializzato in vetrate panoramiche VEPA: dalla consulenza alla progettazione fino all'installazione finale, con competenza tecnica e cura dei dettagli."
      />
      <About />
      <Footer />
    </div>
  );
}
